import { createContext } from 'react';
export const defaultPanelNavigatorContext = {};
export const PanelNavigatorContext = /*#__PURE__*/createContext(defaultPanelNavigatorContext);
export const {
  Consumer,
  Provider
} = PanelNavigatorContext;